const mapClientIdByHostname: Record<string, string> = {
  'demo-app.revers.io': 'demo-field-service-app.revers.io',
  localhost: 'demo-field-service-app.revers.io',
};

const AuthConfiguration = {
  authority: 'https://demo-login.revers.io',
  clientId: 'demo-field-service-app.revers.io',
  scope: 'openid email api',
};

const { hostname } = window.location;

AuthConfiguration.clientId =
  mapClientIdByHostname[hostname] || window.location.hostname;

export default AuthConfiguration;
